import { useState } from "react";
import styles from "./styles.module.css";
import Modal from "react-responsive-modal";
import Table from "../../../components/TableConstructor";
import { MetaAplicacaoRecurso } from "../../../model/PlanoDeTrabalho/PlanoAplicacao";
import RowAplicacaoRecurso from "../../../components/TableConstructor/Row/RowAplicacaoRecurso";
import ModalAplicacaoRecurso from "../../../components/ModalForms/ModalAplicacaoRecurso";
import { MetaFisica } from "../../../model/PlanoDeTrabalho/CronogramaExecucao";

type Props = {
  passarPagina: Function;
  voltarPagina: Function;
  listaAplicacoes: MetaAplicacaoRecurso[];
  title: string;
};

function AplicacaoRecurso({
  passarPagina,
  voltarPagina,
  listaAplicacoes,
  title,
}: Props) {
  return (
    <div>
      <h2 className={styles.titulo}>{title}</h2>

      <Table
        listTitle={[
          "Etapa/Fase",
          "Especificação",
          "Indicador",
          "Custo",
          "Recursos",
          "",
        ]}
        styleList={[1, 0, 1, 1, 1, 0]}
      >
        {listaAplicacoes.map((appObj, index) => (
          <RowAplicacaoRecurso key={index} appObj={appObj} />
        ))}
      </Table>

      <div className="flex justify-between">
        <button
          className={styles.passarTelaBtn}
          onClick={() => {
            voltarPagina();
          }}
        >
          ❮❮ Anterior
        </button>
        <button
          className={styles.passarTelaBtn}
          onClick={() => {
            passarPagina();
          }}
        >
          Proximo ❯❯
        </button>
      </div>
    </div>
  );
}

export default AplicacaoRecurso;
